export default class Project {
    constructor(box21_api) {
        this.api = box21_api;
    }

    async all() {
        let formData = new FormData();
        return this.api.post_with_token('/projects', formData)
    }

    async add(project) {
        let formData = new FormData();
        formData.append('name', project.name);
        formData.append('description', project.description);
        return this.api.post_with_token('/project/add', formData)
    }

    async patch(project) {
        let formData = new FormData();
        formData.append('name', project.name);
        formData.append('project_id', project.id);
        formData.append('description', project.description);
    
        return this.api.post_with_token('/project/patch', formData);        
    }

    async favourite_asset(project_id) {
        let formData = new FormData();
        formData.append('project_id', project_id);
        return this.api.post_with_token('/asset/favourite', formData)
    }

    async delete(project) {
        let formData = new FormData();
        formData.append('project_id', project.id);
        return this.api.post_with_token('/project/delete', formData);
    }

    async importCropDataset(file, options = {}, onProgress) {
        const { v4: uuidV4 } = require("uuid");
        const chunkSize = 500000;
        const totalChunks = Math.max(1, Math.ceil(file.size / chunkSize));
        const uploadId = uuidV4();
        let response = null;
        for (let i = 0; i < totalChunks; i++) {
            const start = i * chunkSize;
            const end = Math.min(start + chunkSize, file.size);
            const chunk = file.slice(start, end);
            const isLast = i === totalChunks - 1;

            const formData = new FormData();
            if (options.project_id) {
                formData.append("project_id", String(options.project_id));
            }
            if (options.project_name) {
                formData.append("project_name", options.project_name);
            }
            if (options.project_description) {
                formData.append("project_description", options.project_description);
            }
            if (options.split) {
                formData.append("split", options.split);
            }
            if (options.limit) {
                formData.append("limit", String(options.limit));
            }
            formData.append("id", uploadId);
            formData.append("chunk_offset", String(start));
            formData.append("is_last", isLast ? "true" : "false");
            formData.append("file", chunk, `${file.name}.part`);

            response = await this.api.post_with_token("/import-crop-dataset", formData);
            if (!response || response.error || (response.data && response.data.error)) {
                return response;
            }
            if (onProgress) {
                onProgress(Math.round(((i + 1) / totalChunks) * 100));
            }
        }
        return response;
    }

}